<template>
  <Breadcrumbs
      title="Edit Distributor Staff"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Distributor Staff', path: '/distributor-staff' },
      { label: 'Edit Distributor Staff', path: '/edit-staff' }
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <editStaff/>
    </div>
  </div>
</template>

<script>
import editStaff from './edit_staff_form.vue'
export default {
  name: 'indexList',
  components: {
    editStaff,
  },
}
</script>